import Api from './Api'

export default {
  getPartners () {
    return Api().get('/partner')
  }
}